export { default } from './AdditionalInfoIcon'
